export default {"src":"/_next/static/media/icone-aura.7285e9f2.svg","height":40,"width":44,"blurWidth":0,"blurHeight":0};